module.exports = __webpack_public_path__ + "static/media/thirteenth_columbus_regional_hospital2.9bb52f34.jpg";